
export type GetCoursesSortOrder = typeof GetCoursesSortOrder[keyof typeof GetCoursesSortOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCoursesSortOrder = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
